import { Routes } from '@angular/router';
import validateQueryParams from './guards/validate-query-params.guard';
import onlyAccountStatusPending from './guards/only-account-status-pending.guard';
import membershipFailed from './guards/membership-failed.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./mobile-renew.component').then((c) => c.MobileRenewComponent),
    canActivate: [validateQueryParams, membershipFailed, onlyAccountStatusPending],
  },
];
